import { render, staticRenderFns } from "./clock-set.vue?vue&type=template&id=2ac721d5&scoped=true"
import script from "./clock-set.vue?vue&type=script&lang=js"
export * from "./clock-set.vue?vue&type=script&lang=js"
import style0 from "./clock-set.vue?vue&type=style&index=0&id=2ac721d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac721d5",
  null
  
)

export default component.exports